import './App.css';
import { AnimateButton, DesktopView, NavBar, Object, Text, Image } from './assets/styles';
import Interface from './Pages/Interface'
import Sky from './assets/img/backgrounds/sky.jpg'
import Footer from './Pages/Footer';
import ArrowDown from './assets/icons/arrow-down.svg'
import { useEffect } from 'react';

function App() {
  useEffect(() => {
   setTimeout(() => {
  document.querySelector('.App').setAttribute('style', 'scale: 1; opacity:1')
  document.querySelector('.Watch').setAttribute('style', 'transform:translateY(35%) rotate(0)')
  document.querySelector('.land1').setAttribute('style', 'transform: translateY(25%)')
  document.querySelector('.land2').setAttribute('style', 'transform: translateY(20%) rotate(10deg)')
  document.querySelector('.backdrop-touch').setAttribute('style', 'transform: translateY(0);opacity:1')
  // rUp()
}, 1500);


document.querySelector('.animate-button').onclick= rUp
})

function rUp() {
  // document.querySelector('.Activity').scrollTop += 5000
  // document.querySelector('.alps').setAttribute('style', 'scale: 1.5')
  // // document.querySelector('.backdrop-text').setAttribute('style', 'transform: translateY(15%) translateX(-42%)')
  document.querySelector('.land1').setAttribute('style', 'transform: translateY(30%)')
  document.querySelector('.land2').setAttribute('style', 'transform: translateY(30%) rotate(10deg)')
  document.querySelector('.backdrop-touch').setAttribute('style', 'transform: translateY(10%);opacity:1')

  document.querySelector('.Watch').setAttribute('style', 'transform:translateY(35%) scale(1.2) rotate(-65deg)')
    document.querySelector('.left-slide-first').setAttribute('style', 'transform: translateX(0)')
    document.querySelector('.left-slide-last').setAttribute('style', 'transform: translateX(0)')
    document.querySelector('.right-slide').setAttribute('style', 'transform: translateX(0)')
  // document.querySelector('.animate-button').setAttribute('style', 'rotate:180deg')
  document.querySelector('.animate-button').onclick= rCont
}

function rCont() {
  document.querySelector('.Activity').scrollTop += 5000
  document.querySelector('.alps').setAttribute('style', 'scale: 1.5')
  // document.querySelector('.backdrop-text').setAttribute('style', 'transform: translateY(15%) translateX(-42%)')
  document.querySelector('.Watch').setAttribute('style', 'transform:translateY(35%) scale(1) rotate(180deg)')
  document.querySelector('.land1').setAttribute('style', 'transform: translateY(50%)')
  document.querySelector('.land2').setAttribute('style', 'transform: translateY(50%) rotate(10deg)')
  document.querySelector('.backdrop-touch').setAttribute('style', 'transform: translateY(200%);opacity:0')

  document.querySelector('.animate-button').setAttribute('style', 'rotate:180deg')
  document.querySelector('.left-slide-first').setAttribute('style', 'transform: translateX(-110%)')
  document.querySelector('.left-slide-last').setAttribute('style', 'transform: translateX(-110%)')
  document.querySelector('.right-slide').setAttribute('style', 'transform: translateX(110%)')

  document.querySelector('.animate-button').onclick= rDown
}
// setTimeout(() => {
//   document.querySelector('.App').setAttribute('style', 'scale: 1; opacity:1')
// }, 1400);


function rDown() {
  document.querySelector('.Activity').scrollTop -= 5000
  document.querySelector('.alps').setAttribute('style', 'scale: 1')
  // document.querySelector('.backdrop-text').setAttribute('style', 'transform: translateY(0) translateX(0)')
  document.querySelector('.Watch').setAttribute('style', 'transform:translateY(35%)  scale(1) rotate(0)')
  document.querySelector('.land1').setAttribute('style', 'transform: translateY(25%)')
  document.querySelector('.land2').setAttribute('style', 'transform: translateY(20%) rotate(10deg)')
  document.querySelector('.backdrop-touch').setAttribute('style', 'transform: translateY(0);opacity:1')

  document.querySelector('.animate-button').setAttribute('style', 'rotate: 0')
  document.querySelector('.left-slide-first').setAttribute('style', 'transform: translateX(-110%)')
  document.querySelector('.left-slide-last').setAttribute('style', 'transform: translateX(-110%)')
  document.querySelector('.right-slide').setAttribute('style', 'transform: translateX(110%)')

  document.querySelector('.animate-button').onclick= rUp
}
  return (
    <DesktopView className="App" bgImg={Sky}>
      <NavBar className='nav-bar'>
      <Object className={'backdrop-text'}>
        <Text size={2.5} className='bold backdrop-col'>
          <Text className='bold'></Text> Series 
        </Text>
      </Object>
      </NavBar>
      <Interface/>
      <AnimateButton className={'animate-button'}>
        <Image src={ArrowDown}/>
      </AnimateButton>
      <Footer/>
    </DesktopView>
  );
}

export default App;